import AxiosConfig from '@/config/axios-config'

export const VideoAPI = {

  listar (pagina, filtro) {
    return AxiosConfig.jalekoAPI().get('/admin/videos',
      {
        params: {
          page: pagina,
          video: filtro.video,
          curso_original_id: filtro.cursoId,
          modulo_original_id: filtro.moduloId,
          licao_original_id: filtro.licaoId,
          tipo_origem_id: filtro.tipo,
          coordenador_professor_id: filtro.coordenador,
          professor_id: filtro.professor,
          criado_em_inicio: filtro.createdDate ? filtro.createdDateRange.startDate : '',
          criado_em_fim: filtro.createdDate ? filtro.createdDateRange.endDate : ''
        }
      }).then(response => response.data)
  },

  vimeosCadastrados () {
    return AxiosConfig.secureJalekoAPI().get('/admin/videos/vimeosCadastrados').then(response => response.data)
  },

  listFromVimeo (pagina, filtro) {
    return AxiosConfig.vimeoAPI().get('/users/21442826/videos', {
      params: {
        per_page: 10,
        page: pagina,
        query: filtro.video,
        direction: 'desc',
        sort: 'date'
      }
    }).then(response => response.data)
  },

  salvar (video) {
    return AxiosConfig.secureJalekoAPI().post('/admin/videos', video).then(response => response.data)
  },

  salvarYoutube (video) {
    return AxiosConfig.secureJalekoAPI().post('/admin/videos/youtube', video).then(response => response.data)
  },

  editarEmMassa (video) {
    return AxiosConfig.secureJalekoAPI().put('/admin/videos', video).then(response => response.data)
  },

  editar (video) {
    return AxiosConfig.secureJalekoAPI().put(`/admin/videos/${video.id}`, video).then(response => response.data)
  },

  deletar (video) {
    return AxiosConfig.secureJalekoAPI().delete(`/admin/videos/${video.id}`, video).then(response => response.data)
  },

  listarTipos () {
    return AxiosConfig.secureJalekoAPI().get('/admin/videos/tipo').then(response => response.data)
  },

  async salvarVimeo (video) {
    return AxiosConfig.secureJalekoAPI().post('/admin/videos/vimeo', video).then(response => response.data)
  },

  async geraUrlUploadVimeo (params) {
    return AxiosConfig.vimeoAPI().post('/me/videos', params)
  },

  async uploadVimeo (url, formData) {
    return AxiosConfig.vimeoAPI().patch(url, formData, {
      headers: {
        'Content-Type': 'application/offset+octet-stream',
        'Upload-Offset': 0,
        'Tus-Resumable': '1.0.0'
      }
    })
  },

  async deletarVideoVimeo (idVimeo) {
    return AxiosConfig.vimeoAPI().delete(`/videos/${idVimeo}`)
  },

  async verificaStatusUpload (url) {
    return AxiosConfig.vimeoAPI().head(url, {
      headers: {
        'Content-Type': 'application/vnd.vimeo.*+json;version=3.4',
        'Tus-Resumable': '1.0.0'
      }
    })
  }

}

export default VideoAPI
